export const LOCATION_IMPORT_TEMPLATE =
  "库位编码,容量,状态\nA1,153,正常\nA9-1,72,正常\n";

export const LOCATION_IMPORT_DROP_HINT =
  "把 CSV 或 Excel 拖到这里。表头是库位编码,容量,状态。模板里的两行是例子，留着就会导入。";
